import { useCallback } from 'react';
import { useApiPost } from '../../api/Api.hooks';

export interface PasswordRecoverRequest {
  email: string;
}

export function usePasswordRecover() {
  const {
    data: success,
    isLoading,
    error,
    post
  } = useApiPost<boolean>('users/password/recover');

  const doPasswordRecover = useCallback(
    (email: string) => {
      post({ email, from: 'app' });
    },
    [post]
  );

  return { success, isLoading, error, doPasswordRecover };
}
